import { IViewPoint } from "@mctypes/frontend.types";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Box, Button, Flex, Group } from "@mantine/core";
import React, { useState } from "react";
import { ConfirmDialog } from "../index";

const Viewpoints: React.FC<{
  viewPoints: IViewPoint[];
  selectedViewPointId: string;
  onClickOnRow: (_id: string) => void;
  onClickOnOpen: (_id: string) => void;
  onDeleteViewPoint: (_id: string) => void;
}> = ({ viewPoints, selectedViewPointId, onClickOnRow, onClickOnOpen, onDeleteViewPoint }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const deleteVp = (_id: string) => {
    onDeleteViewPoint(_id);
  };

  const columns: ColDef[] = [
    {
      field: "title",
      headerName: "Navn",
      cellClass: "cell-px0",
      flex: 1,
      maxWidth: 200,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
        wordBreak: "break-word",
      },
      onCellClicked: (params) => onClickOnRow(params.data._id),
      cellRenderer: (params) => {
        return (
          <Box
            className="two-line-text-truncate"
            pl="0.5rem"
            style={{ borderLeft: params.data._id === selectedViewPointId ? "5px solid #3b92e1" : "", width: "100%" }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: "status.title",
      headerName: "Status",
      width: 80,
      onCellClicked: (params) => onClickOnRow(params.data._id),
    },
    {
      field: "_id",
      headerName: "",
      cellClass: "cell-flex cell-align-center cell-justify-center cell-p0",
      width: 68,
      minWidth: 68,
      maxWidth: 68,
      suppressMovable: true,
      cellStyle: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      cellRenderer: (params) => {
        return (
          <Group gap={2} wrap="nowrap">
            <Button
              size="sm"
              variant="outline"
              color="mc-blue"
              style={{ borderStyle: "none", paddingInline: 4, minWidth: 24, height: 24 }}
              onClick={() => onClickOnOpen(params.value)}
            >
              <i className="fa fa-ellipsis-h" />
            </Button>
            <ConfirmDialog
              title="Slette viewpoint"
              message="Er du sikker på at du vil slette denne viewpointen?"
              confirmCb={() => deleteVp(params.value)}
            >
              <Button
                size="sm"
                variant="outline"
                color="mc-blue"
                style={{ borderStyle: "none", paddingInline: 4, minWidth: 24, height: 24 }}
              >
                <i className="fa fa-trash-o" />
              </Button>
            </ConfirmDialog>
          </Group>
        );
      },
    },
  ];

  return (
    <Flex className="border" h="100%" pos="relative" style={{ overflow: "auto" }}>
      <Box
        h="100%"
        bg="gray.4"
        style={{ width: "30px", cursor: "pointer" }}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <Flex h="100%" justify="center" align="center">
          <div>
            <i
              className={isCollapsed ? "fa fa-angle-double-left fa-fw fa-2x" : "fa fa-angle-double-right fa-fw fa-2x"}
            />
          </div>
        </Flex>
      </Box>
      {isCollapsed === false && (
        <Box style={{ width: "500px" }}>
          <div className="ag-theme-quartz" style={{ height: "100%", width: "100%" }}>
            <AgGridReact
              domLayout={"autoHeight"}
              rowData={viewPoints || []}
              defaultColDef={{
                suppressHeaderMenuButton: true,
                cellClass: "cell-block cell-px2",
              }}
              headerHeight={35}
              columnDefs={columns}
              suppressClickEdit={true}
              animateRows={false}
              suppressContextMenu={true}
            />
          </div>
        </Box>
      )}
    </Flex>
  );
};

export default Viewpoints;
